import styled from 'styled-components/macro';
import SimpleButton from 'styled/Buttons/SimpleButton';
import { COLORS } from 'styleguide';

const Filter = styled(SimpleButton)`
  width: 100%;
  padding: 10px 24px 10px 16px;
  text-align: left;
  ${({ isActive }) => isActive && `
    background-color: ${COLORS.black};
    opacity: 1;
  `}
  outline: none;
  transition: background-color 0.15s ease-out;

  &:hover,
  &:focus {
    background-color: ${COLORS.black};
  }
`;

export default Filter;
